import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class RouteDirectionActions {
    static SET_ROUTE_DIRECTIONS_ENTITY = '[Schedule]: Set route directions entity';
    static SET_SELECTED_ROUTE_DIRECTION = '[Schedule]: Set selected route direction';

    setRouteDirectionEntity(routeDirectionEntity): RidangoReduxAction {
        return {
            type: RouteDirectionActions.SET_ROUTE_DIRECTIONS_ENTITY,
            payload: routeDirectionEntity,
        };
    }

    setSelectedRouteDirection(id): RidangoReduxAction {
        return {
            type: RouteDirectionActions.SET_SELECTED_ROUTE_DIRECTION,
            payload: id,
        };
    }
}
